<template lang="pug">
  router-view
</template>

<script>
  import axios from 'axios'
  
  export default {
    beforeCreate () {
      if (this.$ls.get('token', false)) axios.defaults.headers.common['Authorization'] = this.$ls.get('token')
      else this.$router.push('/login')
    }
  }
</script>



// WEBPACK FOOTER //
// condo.vue?097dad78